import { getMonthShortAbbreviation } from '@common/neo.tax';

export const getCapitalizationDateString = (date: Date | null): string => {
  if (!date) {
    return '';
  }
  const month = getMonthShortAbbreviation(date.getUTCMonth());
  const year = date.getUTCFullYear();
  return `${month} ${year}`;
};

// Shared copy for the auto-derived Project Start / End dates, used as the column
// header tooltip in the projects table and as the description in the project
// detail drawer so both surfaces stay in sync.
export const PROJECT_DATES_DESCRIPTION = 'Automatically determined from project allocation and ticket activity.';
